import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withRouter } from 'react-router';
import { SKILL_NUMBER_MAP } from './constants';
import { AP_ENGLISH_LANG } from 'chameleon-src/constants/subjects';

import './styles.scss';

/**
 * Draws practice skill box
 * */
const PracticeSkillBox = React.forwardRef((props, ref) => {
  const {
    label,
    index,
    onClick,
    setCount,
    ariaDescribedBy,
    ariaHidden,
    tabIndex,
    colorIndex,
    params: { subject } = {},
    role,
    activeRef,
    ariaExpanded,
    skillName,
  } = props;
  const subjectId = parseInt(subject, 10);
  const [newLabel] = skillName.split(':');
  const [skillData] = label ? label.split('.') : newLabel.split('.');

  let skillNumber;
  let useSecondColor = false;
  if (Number.parseInt(skillData, 10)) {
    skillNumber = skillData;
  } else {
    const skillNumberMapKeys = Object.keys(SKILL_NUMBER_MAP);
    skillNumber = skillNumberMapKeys.find((key) =>
      SKILL_NUMBER_MAP[key].map((x) => x.text).includes(skillData),
    );
    ({ useSecondColor } =
      (SKILL_NUMBER_MAP[skillNumber] || []).find(
        (skillDataMap) => skillDataMap.text === skillData,
      ) || {});
  }

  const skillsTemplate =
    subjectId === AP_ENGLISH_LANG ? 'custom-template' : 'default-template';
  const className = cn(
    `cursor-pointer PracticeSkill--box ${skillsTemplate} skill-${
      colorIndex || skillNumber
    }`,
    { 'with-second-color': useSecondColor },
  );

  const setOnFocus = () => {
    if (setCount) {
      setCount(index);
    }
  };

  const onChipClick = () => {
    onClick(index);
  };
  return (
    <span
      data-test-skillbox-element
      onClick={onChipClick}
      className={className}
      tabIndex={tabIndex}
      aria-hidden={ariaHidden}
      onFocus={() => (tabIndex === 0 ? setOnFocus() : null)}
      role={role}
      aria-label={label || newLabel}
      ref={activeRef || ref}
      aria-describedby={ariaDescribedBy}
      aria-expanded={ariaExpanded}
    >
      {label || newLabel}
    </span>
  );
});

PracticeSkillBox.displayName = 'PracticeSkillBox';

PracticeSkillBox.propTypes = {
  label: PropTypes.string.isRequired,
  index: PropTypes.number,
  onClick: PropTypes.func,
  ariaHidden: PropTypes.bool,
  colorIndex: PropTypes.string,
  role: PropTypes.string,
  ariaExpanded: PropTypes.bool,
  skillName: PropTypes.string,
};

PracticeSkillBox.defaultProps = {
  tabIndex: 0,
  ariaHidden: false,
  onClick: () => {},
  colorIndex: '',
  role: 'button',
  ariaExpanded: false,
  skillName: '',
};

export default withRouter(PracticeSkillBox);
